import { createElement } from 'react';
import { cx } from '@emotion/css';
import { AppFCC, USER_ACHIEVEMENT } from '@types';
import { UserAchievementsChipsProps } from '@kit/user-achievements-chips/types';
import { CoachAchievementIcon, ConsultantAchievementIcon, ConsultantFreeIcon, PsychologistAchievementIcon, SexologistAchievementIcon } from '@icons';
import { userAchievementsChipsChipClassName, UserAchievementsChipsStyled } from './styled';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const UserAchievementsChips: AppFCC<UserAchievementsChipsProps> = props => {
  const {
    className,
    chipClassName,
    achievements
  } = props;
  const chipProps = {
    width: undefined,
    className: cx(userAchievementsChipsChipClassName, chipClassName)
  };
  const achievementChipIcons = {
    [USER_ACHIEVEMENT.COACH]: CoachAchievementIcon,
    [USER_ACHIEVEMENT.DIPLOMA]: PsychologistAchievementIcon,
    [USER_ACHIEVEMENT.SEXOLOGIST]: SexologistAchievementIcon,
    [USER_ACHIEVEMENT.CONSULTANT]: ConsultantAchievementIcon,
    [USER_ACHIEVEMENT.FREE_CONSULTANT]: ConsultantFreeIcon
  };
  return _jsx(UserAchievementsChipsStyled, {
    className: className,
    children: achievements.map(achievement => {
      return /*#__PURE__*/createElement(achievementChipIcons[achievement],
      //
      {
        key: achievement,
        ...chipProps
      });
    })
  });
};